// extracted by mini-css-extract-plugin
module.exports = {"title":"TrendingDestinations-module__title___NeSTW","carousel":"TrendingDestinations-module__carousel___PnptN"};